import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { getPageStaticProps } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import { LanaBob } from '@/components/LearnMore/LandBob';
import { CreatorsRock } from 'components/AboutUs/CreatorsRock';
import Mission from '@/components/LearnMore/Mission';
import FounderSection from '@/components/Parents/FounderSection';
import MailingList from '@/components/MailingList/MailingList';
import TeamWork from '@/components/AboutUs/TeamWork';
import { SignupBlock } from '@/components/SignupBlock/SignupBlock';
import ImageBarSection from '@/components/Trustbar2/ImageBarSection';

const About = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    return (
        <Layout showClassCodeInput={false}>
            <NextSeo title={seo?.title} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>

            <Mission heading={components[0].heading} featuredImage={components[0].featuredImage} id='about-us-mission' />

            <LanaBob heading={components[7].heading} infoItems={components[7].infoItems} id='about-us-lana-bob' />

            <CreatorsRock id='about-us-creators-rock' />

            <TeamWork component={components[1]} id='about-us-teamwork' />

            {/*
            <div className='hidden lg:block pb-[40px] mt-10 sm:mb-16 lg:mb-40'>
                <Trustbar2 logos={components[2].gallery} phoneImageMaxWidth='80px' flexWrap='wrap' />
            </div>
            */}
            <ImageBarSection id='about-us-image-bar-desktop' images={components[2].gallery} className='pb-[40px] mt-8 lg:mb-40 hidden lg:block' />

            <FounderSection
                heading={components[4].heading}
                smallHeading={components[4].smallHeading}
                subhead={components[4].subhead}
                videoLink={components[4].videoLink}
                background='#fff'
                id='about-us-founder'
            />

            {/*
            <div className='hidden mb-4 sm:mb-6 md:mb- my-6  default-max-w mx-auto'>
                <Trustbar2 logos={components[2].gallery} phoneImageMaxWidth='80px' flexWrap='wrap' />
            </div>
            */}
            <ImageBarSection id='about-us-image-bar-mobile' images={components[2].gallery} className='block lg:hidden mb-4 sm:mb-6 mt-2 mb-6' />


            <MailingList background='none' id='about-us-mailing-list' />

            <SignupBlock heading={components[5]?.heading} smallHeading={components[5]?.smallHeading} videoLink={components[5]?.videoLink} id='about-us-singup-block' />
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('About');
}

export default About;
